import { connect } from 'react-redux';
import { MODAL } from 'constants';
import { breakpointSelector, selectedBundleWithExtrasSelector, hashTableOfRecommendedExtrasSelector } from 'selectors';
import { exclusionsSelector, getReservationLimitedAdvanceNoticeIndicator } from 'selectors/reservationSelectors';
import { extrasUpdate } from 'actions/reservation/extrasUpdate';
import { openModal } from 'actions/modal/openModal';
import Extra from './Extra';

const mapStateToProps = (state, props) => {
  const bundleExtras = selectedBundleWithExtrasSelector(state)?.bundleExtras || [];
  const extraInBundle = bundleExtras?.find((ext) => ext.code === props.extra.code);
  const isBundleIncluded = !!extraInBundle;
  const selectedMoreThanBundled = isBundleIncluded && extraInBundle.selected_quantity < props.extra.selected_quantity;
  return {
    breakpoint: breakpointSelector(state),
    exclusions: exclusionsSelector(state, props.extra.lrd_policy_code),
    isBundleIncluded,
    selectedMoreThanBundled,
    hashTableOfRecommendedExtras: hashTableOfRecommendedExtrasSelector(state),
    reservationLimitedAdvanceNoticeIndicator: getReservationLimitedAdvanceNoticeIndicator(state),
  };
};

const mapDispatchToProps = {
  extrasUpdate,
  showExclusionsModal: (header, gboCopy) =>
    openModal(MODAL.EXTRAS_EXCLUSION_MODAL, { props: { header, gboCopy, modalKey: MODAL.EXTRAS_EXCLUSION_MODAL } }),
  openLimitedInventoryModal: (handleAccept, code) =>
    openModal(MODAL.LIMITED_INVENTORY, { props: { handleAccept, code } }),
  openLimitedAdaptiveEquipmentModal: (handleAccept, code) =>
    openModal(MODAL.ADAPTIVE_DRIVING_DEVICE, { props: { handleAccept, code }, skipAnalytics: true }),
};

export default connect(mapStateToProps, mapDispatchToProps)(Extra);
